{
  "title": "Assignment rules",
  "subtitle": "Evaluated top to bottom. The first rule that matches a sender wins and evaluation stops.",
  "newRule": "New rule",
  "testRules": "Test a sender",
  "loadError": "Could not load rules",
  "emptyTitle": "No rules yet",
  "emptyBody": "Without a default or a rule, nothing is stamped: every message falls through and is relayed unmodified. Set a default signature on the Users tab, or add a narrower rule here.",
  "tenantDefault": "Tenant default",
  "tenantDefaultHint": "Applies when no operator rule matches.",
  "reorderError": "Could not reorder rules.",
  "reorderFailed": "Reorder failed.",
  "deleteRule": "Delete rule",
  "deleteConfirm": "Delete “{{name}}”?",
  "deleted": "Deleted \"{{name}}\".",
  "deleteError": "Could not delete that rule.",
  "editRule": "Edit “{{name}}”",
  "createRule": "New rule",
  "ruleName": "Name",
  "ruleNamePlaceholder": "Sales — external disclaimer",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "template": "Template",
  "injectionMode": "Injection path",
  "injectionBoth": "Both",
  "injectionBothPaths": "Both paths",
  "injectionMailFlow": "Mail flow only",
  "injectionClient": "Client only",
  "injectionMailFlowShort": "Mail flow",
  "injectionClientShort": "Client",
  "unknownPath": "Unknown path",
  "recipientScope": "Recipients",
  "recipientAny": "Any",
  "recipientAnyFull": "Any recipient",
  "recipientInternal": "Internal only",
  "recipientExternal": "External only",
  "unknownRecipients": "Unknown recipients",
  "recipientsHint": "Judged on the envelope. A message with no recipients satisfies neither internal nor external, so a scoped rule simply does not match rather than guessing.",
  "templateNew": "Signature for new messages",
  "templateNewShort": "New: {{name}}",
  "templateNewNone": "New: no template",
  "templateReply": "Signature for replies",
  "templateReplyShort": "Reply: {{name}}",
  "templateReplySame": "Reply: same as new",
  "templateNone": "None",
  "templateReplyPlaceholder": "Same as new messages",
  "unknownTemplate": "Unknown template",
  "appliesTo": "Applies to",
  "except": "Except",
  "emptyScopeTitle": "This rule matches nobody",
  "emptyScopeBody": "An empty scope never fires. Pick at least one facet, or turn on Everyone.",
  "emptyScopeBadge": "Matches nobody",
  "emptyScopeTooltip": "An empty sender scope matches nobody, so this rule never fires.",
  "hasExclusions": "Has exclusions",
  "addExclusions": "Add exclusions",
  "removeExclusions": "Remove exclusions",
  "exclusionsHint": "Excluded senders fall through to lower-priority rules rather than losing their signature entirely.",
  "saveRule": "Save rule",
  "saved": "Rule saved.",
  "saveError": "Could not save the rule",
  "testerTitle": "Test a sender",
  "testerHint": "Pick a mailbox to see which rule would win and which signature they would get.",
  "senderAddress": "Sender address",
  "senderPlaceholder": "jordan.avery@contoso.com.au",
  "recipientsLabel": "Recipients",
  "recipientsDescription": "Envelope recipients. Internal-only and external-only rules are judged against these.",
  "recipientsPlaceholder": "Add a recipient and press Enter",
  "runTest": "Run test",
  "testError": "Could not run the test",
  "noRuleMatched": "No rule matched",
  "noRulesEvaluated": "No rules were evaluated.",
  "colPriority": "Priority",
  "colRule": "Rule",
  "colOutcome": "Outcome",
  "colWhy": "Why",
  "traceMatched": "Matched",
  "traceShadowed": "Shadowed",
  "traceDisabled": "Disabled",
  "traceSenderOutOfScope": "Sender out of scope",
  "traceExcludedByRule": "Excluded by rule",
  "traceRecipientScope": "Recipient scope",
  "traceWrongPath": "Wrong path",
  "traceNotEvaluated": "Not evaluated",
  "traceUnknown": "Unknown",
  "excludedTitle": "Sender is excluded",
  "excludedBody": "This address is flagged as excluded in the directory, so mail from it is relayed untouched and no rule is ever evaluated. There is nothing to trace.",
  "excludedHint": "Exclusion is set on the directory user, not in these rules. Clear it there if this sender should be stamped.",
  "primaryDefault": "Primary default",
  "defaultBadge": "Default",
  "everyone": "Everyone",
  "noMailboxesCovered": "No mailboxes are covered yet.",
  "mailboxesCovered": "{{count}} mailbox covered.",
  "mailboxesCovered_other": "{{count}} mailboxes covered.",
  "mailboxesCoveredWithCustom": "{{count}} mailbox covered, {{custom}} with a signature set individually.",
  "mailboxesCoveredWithCustom_other": "{{count}} mailboxes covered, {{custom}} with a signature set individually.",
  "managedOnUsers": "Managed on the",
  "usersTab": "Users tab",
  "changeDefault": "Change default",
  "reorderAria": "Reorder {{name}}",
  "moreActionsAria": "More actions for {{name}}",
  "edit": "Edit",
  "facetEveryone": "Everyone",
  "facetUsers": "Users",
  "facetGroups": "Groups",
  "facetDomains": "Domains",
  "facetConditions": "Conditions",
  "everyoneLabel": "Apply to everyone in the tenant",
  "everyoneDescription": "The explicit catch-all. Without it, a scope with no other facet set matches nobody.",
  "directoryUsers": "Directory users",
  "searchUsers": "Search users",
  "userExcludedSuffix": " (excluded)",
  "emailAddresses": "Email addresses",
  "emailAddressesDescription": "Matched against every proxy address, so aliases and shared mailboxes resolve too.",
  "emailAddressesPlaceholder": "name@example.com",
  "groupsLabel": "Groups",
  "searchGroups": "Search groups",
  "groupsDescription": "Nested membership is flattened at sync time, so a user in a nested group matches.",
  "senderDomains": "Sender domains",
  "senderDomainsDescription": "Matched against the domain part of the sending address.",
  "senderDomainsPlaceholder": "contoso.com.au",
  "conditionsEmptyHint": "No attribute conditions. Add one to target by department, office, or a custom attribute.",
  "facetsUnionHint": "Facets combine as a union: anyone matched by any facet is in scope.",
  "match": "Match",
  "attribute": "Attribute",
  "usersHaveValue": "{{count}} users have a value",
  "attributeNotSeen": "Not seen on any synced user",
  "value": "Value",
  "valueInPlaceholder": "Sales, Marketing",
  "removeCondition": "Remove condition",
  "addCondition": "Add condition",
  "operatorEquals": "is",
  "operatorNotEquals": "is not",
  "operatorContains": "contains",
  "operatorStartsWith": "starts with",
  "operatorEndsWith": "ends with",
  "operatorIsEmpty": "is empty",
  "operatorIsNotEmpty": "is not empty",
  "operatorIn": "is one of"
}
